import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scores"
export default class extends Controller {
  static targets = ["toggleBtn", "toggleText", "feedbackImage"]
  static values = { 
    showText: String, 
    hideText: String 
  }

  connect() {
    this.criteriaVisible = false
    this.initializeCriteriaVisibility()
  }

  // Переключение видимости колонок критериев
  toggleCriteria() {
    this.criteriaVisible = !this.criteriaVisible

    // Находим все колонки критериев по классу
    const criteriaColumns = document.querySelectorAll('.criteria-column')
    const criteriaHeaders = document.querySelectorAll('.criteria-header')

    criteriaColumns.forEach(column => {
      column.style.display = this.criteriaVisible ? '' : 'none'
    })

    criteriaHeaders.forEach(header => {
      header.style.display = this.criteriaVisible ? '' : 'none'
    })

    // Обновляем текст и иконку кнопки
    this.updateToggleButton()
  }

  // Обработчик клика по фото обратной связи
  showFeedbackPhoto(event) {
    const feedbackUrl = event.currentTarget.dataset.feedbackUrl
    if (feedbackUrl && this.hasFeedbackImageTarget) {
      this.feedbackImageTarget.src = feedbackUrl
    }
  }

  // Приватные методы

  initializeCriteriaVisibility() {
    // Изначально скрываем все критерии
    const criteriaColumns = document.querySelectorAll('.criteria-column')
    const criteriaHeaders = document.querySelectorAll('.criteria-header')

    criteriaColumns.forEach(column => {
      column.style.display = 'none'
    })

    criteriaHeaders.forEach(header => {
      header.style.display = 'none'
    })
  }

  updateToggleButton() {
    if (!this.hasToggleTextTarget || !this.hasToggleBtnTarget) return

    const icon = this.toggleBtnTarget.querySelector('i')
    
    if (this.criteriaVisible) {
      this.toggleTextTarget.textContent = this.hideTextValue
      if (icon) icon.className = 'fa-solid fa-eye-slash me-2'
    } else {
      this.toggleTextTarget.textContent = this.showTextValue
      if (icon) icon.className = 'fa-solid fa-eye me-2'
    }
  }
}